import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getReportReserveProductSummary } from "../../redux/handlers/report/getReportReserveProductSummary.handler";
import { allBrand } from "../../redux/handlers/manage/allBrand.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { formatNumber, filterTextAndNum } from "utils/HelperFunction";
var numberText = function(value) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return formatNumber(Number(value || 0), digit) || "0.00";
};
var integerText = function(value) {
    return formatNumber(Number(value || 0), 0) || "0";
};
var dateText = function(value) {
    return value && moment(value).isValid() ? moment(value).format("DD/MM/YYYY HH:mm") : "-";
};
var getSaleStatusStyle = function() {
    var statusId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var status = Number(statusId);
    if (status === 4) {
        return {
            color: "#6f42c1",
            backgroundColor: "#e2d9f3"
        };
    }
    if (status === 3) {
        return {
            color: "rgba(211, 47, 47, 1)",
            backgroundColor: "rgba(253, 237, 237, 1)"
        };
    }
    if (status === 2) {
        return {
            color: "rgba(255, 255, 255, 1)",
            backgroundColor: "rgba(16, 176, 42, 1)"
        };
    }
    if (status === 1) {
        return {
            color: "rgba(253, 180, 40, 1)",
            backgroundColor: "rgba(255, 246, 229, 1)"
        };
    }
    return {
        color: "rgba(116, 116, 116, 1)",
        backgroundColor: "rgba(244, 244, 244, 1)"
    };
};
var getReserveStatusStyle = function() {
    var statusId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var status = Number(statusId);
    if (status === 4) {
        return {
            color: "#0a58ca",
            backgroundColor: "#e7f1ff"
        };
    }
    if (status === 5) {
        return {
            color: "#8a4b00",
            backgroundColor: "#fff3cd"
        };
    }
    if (status === 7) {
        return {
            color: "#0f766e",
            backgroundColor: "#ccfbf1"
        };
    }
    if (status === 2) {
        return {
            color: "#ffffff",
            backgroundColor: "#10b02a"
        };
    }
    if (status === 6) {
        return {
            color: "#075985",
            backgroundColor: "#e0f2fe"
        };
    }
    if (status === 3) {
        return {
            color: "rgba(211, 47, 47, 1)",
            backgroundColor: "rgba(253, 237, 237, 1)"
        };
    }
    if (status === 1) {
        return {
            color: "rgba(253, 180, 40, 1)",
            backgroundColor: "rgba(255, 246, 229, 1)"
        };
    }
    return {
        color: "rgba(116, 116, 116, 1)",
        backgroundColor: "rgba(244, 244, 244, 1)"
    };
};
var StatusBadge = function(param) {
    var label = param.label, style = param.style;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-100 text-center",
        children: /*#__PURE__*/ _jsx("span", {
            className: "d-inline-block px-2 py-1 text-center",
            style: _object_spread_props(_object_spread({}, style), {
                borderRadius: "20px",
                minWidth: "130px",
                fontWeight: 500
            }),
            children: label || "-"
        })
    });
};
var reserveSummarySaleStatusOptions = [
    {
        value: 1,
        label: "รอติดต่อ"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var reserveSummaryReserveStatusOptions = [
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        value: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        value: 5,
        label: "รอส่งสินค้า"
    },
    {
        value: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        value: 6,
        label: "ชำระเงินแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var sortOptionsByLabelAsc = function(options) {
    return _to_consumable_array(options).sort(function(a, b) {
        return String(a.label || "").localeCompare(String(b.label || ""), "en", {
            sensitivity: "base"
        });
    });
};
var SummaryBox = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3 py-2 border rounded bg-light h-100",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "fs-14 tc-7",
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fs-20 fw-semibold",
                children: value
            })
        ]
    });
};
var UnitLines = function(param) {
    var row = param.row, render = param.render;
    var units = row.product_unit_summary || [];
    if (!units.length) return /*#__PURE__*/ _jsx("span", {
        children: "-"
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "w-100",
        children: units.map(function(unit, index) {
            return /*#__PURE__*/ _jsx("div", {
                className: index > 0 ? "pt-1 mt-1 border-top" : "",
                children: render(unit)
            }, "".concat(unit.unit_id || "unit", "-").concat(index));
        })
    });
};
export function ReportReserveProductSummary() {
    var _reservationModal_product, _reservationModal_product1;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), rowData = _useState[0], setRowData = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), summary = _useState1[0], setSummary = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), brandOptions = _useState2[0], setBrandOptions = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), shopOptions = _useState3[0], setShopOptions = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), saleOptions = _useState4[0], setSaleOptions = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), brandId = _useState5[0], setBrandId = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), shopId = _useState6[0], setShopId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), saleId = _useState7[0], setSaleId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), searchTxt = _useState8[0], setSearchTxt = _useState8[1];
    var _useState9 = _sliced_to_array(useState([
        reserveSummarySaleStatusOptions[1]
    ]), 2), saleStatuses = _useState9[0], setSaleStatuses = _useState9[1];
    var _useState10 = _sliced_to_array(useState([
        reserveSummaryReserveStatusOptions[3],
        reserveSummaryReserveStatusOptions[4]
    ]), 2), reserveStatuses = _useState10[0], setReserveStatuses = _useState10[1];
    var _useState11 = _sliced_to_array(useState(moment().startOf("month").format("YYYY-MM-DD")), 2), startDate = _useState11[0], setStartDate = _useState11[1];
    var _useState12 = _sliced_to_array(useState(moment().format("YYYY-MM-DD")), 2), endDate = _useState12[0], setEndDate = _useState12[1];
    var _useState13 = _sliced_to_array(useState("months_1"), 2), dateRange = _useState13[0], setDateRange = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        brandId: "",
        shopId: "",
        saleId: "",
        searchTxt: "",
        saleStatuses: [
            reserveSummarySaleStatusOptions[1]
        ],
        reserveStatuses: [
            reserveSummaryReserveStatusOptions[3],
            reserveSummaryReserveStatusOptions[4]
        ],
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    }), 2), filters = _useState14[0], setFilters = _useState14[1];
    var _useState15 = _sliced_to_array(useState(1), 2), pageId = _useState15[0], setPageId = _useState15[1];
    var _useState16 = _sliced_to_array(useState(10), 2), pageSize = _useState16[0], setPageSize = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), totalPage = _useState17[0], setTotalPage = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), totalAmount = _useState18[0], setTotalAmount = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), sortModel = _useState19[0], setSortModel = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        show: false,
        product: null,
        reservations: []
    }), 2), reservationModal = _useState20[0], setReservationModal = _useState20[1];
    var _useState21 = _sliced_to_array(useState(1), 2), reservationModalPageId = _useState21[0], setReservationModalPageId = _useState21[1];
    var _useState22 = _sliced_to_array(useState(10), 2), reservationModalPageSize = _useState22[0], setReservationModalPageSize = _useState22[1];
    var _useState23 = _sliced_to_array(useState({}), 2), reservationModalSortModel = _useState23[0], setReservationModalSortModel = _useState23[1];
    var getReportReserveProductSummaryReducer = useAppSelector(function(state) {
        return state.getReportReserveProductSummaryReducer;
    });
    var allBrandReducer = useAppSelector(function(state) {
        return state.allBrandReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getSaleStatusText = function(status) {
        var _reserveSummarySaleStatusOptions_find;
        return ((_reserveSummarySaleStatusOptions_find = reserveSummarySaleStatusOptions.find(function(item) {
            return item.value === Number(status);
        })) === null || _reserveSummarySaleStatusOptions_find === void 0 ? void 0 : _reserveSummarySaleStatusOptions_find.label) || "-";
    };
    var getReserveStatusText = function(status) {
        var _reserveSummaryReserveStatusOptions_find;
        return ((_reserveSummaryReserveStatusOptions_find = reserveSummaryReserveStatusOptions.find(function(item) {
            return item.value === Number(status);
        })) === null || _reserveSummaryReserveStatusOptions_find === void 0 ? void 0 : _reserveSummaryReserveStatusOptions_find.label) || "-";
    };
    var openReservationModal = function(row) {
        setReservationModalPageId(1);
        setReservationModalSortModel({});
        setReservationModal({
            show: true,
            product: row,
            reservations: row.reservations || []
        });
    };
    var modalReservationColumns = useMemo(function() {
        return [
            {
                name: "รหัสใบจอง",
                selector: function(row) {
                    return row.rs_reserve_code || "";
                },
                sortable: true,
                sortField: "rs_reserve_code",
                width: "150px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF",
                            fontWeight: 500
                        },
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "me-2",
                            to: "/report/reservation/view/".concat(row.rs_reserve_id),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: row.rs_reserve_code || "ไม่มีรหัส"
                        })
                    });
                }
            },
            {
                name: "วันที่จอง",
                selector: function(row) {
                    return row.rs_reserve_credate || "";
                },
                sortable: true,
                sortField: "rs_reserve_credate",
                width: "150px",
                cell: function(row) {
                    return dateText(row.rs_reserve_credate);
                }
            },
            {
                name: "ร้านค้า",
                selector: function(row) {
                    return row.rs_reserve_shopname || "-";
                },
                sortable: true,
                sortField: "rs_reserve_shopname",
                minWidth: "180px"
            },
            {
                name: "สาขา",
                selector: function(row) {
                    return row.rs_reserve_branchname || "-";
                },
                sortable: true,
                sortField: "rs_reserve_branchname",
                minWidth: "180px"
            },
            {
                name: "เซลล์",
                selector: function(row) {
                    return row.rs_reserve_salename || "-";
                },
                sortable: true,
                sortField: "rs_reserve_salename",
                minWidth: "160px"
            },
            {
                name: "สถานะเซลล์",
                selector: function(row) {
                    return getSaleStatusText(row.rs_reserve_salestatus);
                },
                sortable: true,
                sortField: "rs_reserve_salestatus",
                center: true,
                minWidth: "140px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(StatusBadge, {
                        label: getSaleStatusText(row.rs_reserve_salestatus),
                        style: getSaleStatusStyle(row.rs_reserve_salestatus)
                    });
                }
            },
            {
                name: "สถานะใบจอง",
                selector: function(row) {
                    return getReserveStatusText(row.rs_reserve_status);
                },
                sortable: true,
                sortField: "rs_reserve_status",
                center: true,
                minWidth: "140px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(StatusBadge, {
                        label: getReserveStatusText(row.rs_reserve_status),
                        style: getReserveStatusStyle(row.rs_reserve_status)
                    });
                }
            },
            {
                name: "จำนวนจอง",
                selector: function(row) {
                    return row.reserve_amount_item || 0;
                },
                sortable: true,
                sortField: "reserve_amount_item",
                right: true,
                width: "130px",
                cell: function(row) {
                    return integerText(row.reserve_amount_item);
                }
            },
            {
                name: "มูลค่าจอง",
                selector: function(row) {
                    return row.reserve_net || 0;
                },
                sortable: true,
                sortField: "reserve_net",
                right: true,
                width: "140px",
                cell: function(row) {
                    return numberText(row.reserve_net);
                }
            },
            {
                name: "จำนวนส่งจริง",
                selector: function(row) {
                    return row.delivery_amount_item || 0;
                },
                sortable: true,
                sortField: "delivery_amount_item",
                right: true,
                width: "150px",
                cell: function(row) {
                    return integerText(row.delivery_amount_item);
                }
            },
            {
                name: "มูลค่าส่งจริง",
                selector: function(row) {
                    return row.delivery_net || 0;
                },
                sortable: true,
                sortField: "delivery_net",
                right: true,
                width: "150px",
                cell: function(row) {
                    return numberText(row.delivery_net);
                }
            }
        ];
    }, [
        getReserveStatusText,
        getSaleStatusText
    ]);
    var modalReservations = useMemo(function() {
        var rows = _to_consumable_array(reservationModal.reservations || []);
        var field = reservationModalSortModel === null || reservationModalSortModel === void 0 ? void 0 : reservationModalSortModel.sortField;
        var direction = (reservationModalSortModel === null || reservationModalSortModel === void 0 ? void 0 : reservationModalSortModel.sortValue) === "desc" ? -1 : 1;
        if (!field) return rows;
        return rows.sort(function(a, b) {
            var aValue = a === null || a === void 0 ? void 0 : a[field];
            var bValue = b === null || b === void 0 ? void 0 : b[field];
            if (typeof aValue === "number" || typeof bValue === "number") {
                return (Number(aValue || 0) - Number(bValue || 0)) * direction;
            }
            return String(aValue || "").localeCompare(String(bValue || ""), "th", {
                numeric: true,
                sensitivity: "base"
            }) * direction;
        });
    }, [
        reservationModal.reservations,
        reservationModalSortModel
    ]);
    var paginatedModalReservations = useMemo(function() {
        var start = (reservationModalPageId - 1) * reservationModalPageSize;
        return modalReservations.slice(start, start + reservationModalPageSize);
    }, [
        modalReservations,
        reservationModalPageId,
        reservationModalPageSize
    ]);
    var handleModalSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        if (!field) return;
        setReservationModalSortModel({
            sortField: field,
            sortValue: sortDirection
        });
        setReservationModalPageId(1);
    };
    var columns = useMemo(function() {
        return [
            {
                name: "จำนวนใบจอง",
                selector: function(row) {
                    return row.reserve_count || 0;
                },
                sortable: true,
                sortField: "reserve_count",
                center: true,
                minWidth: "60px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "w-100 text-center",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "p-0 fw-semibold text-decoration-underline",
                            disabled: !row.reserve_count,
                            onClick: function() {
                                return openReservationModal(row);
                            },
                            children: integerText(row.reserve_count)
                        })
                    });
                }
            },
            {
                name: "รหัสสินค้า",
                selector: function(row) {
                    return row.product_code || "-";
                },
                sortable: true,
                sortField: "product_code",
                minWidth: "150px",
                cell: function(row) {
                    return row.product_id ? /*#__PURE__*/ _jsx(Link, {
                        to: "/productlist/edit/".concat(row.product_id, "/view"),
                        style: {
                            color: "#565DFF",
                            fontWeight: 500
                        },
                        children: row.product_code || "-"
                    }) : row.product_code || "-";
                }
            },
            {
                name: "ชื่อสินค้า",
                selector: function(row) {
                    return row.product_nameth || row.product_nameen || "-";
                },
                sortable: true,
                sortField: "product_nameth",
                minWidth: "280px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: row.product_nameth || "-"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "tc-7 fs-14",
                                children: row.product_nameen || "-"
                            })
                        ]
                    });
                }
            },
            {
                name: "บาร์โค้ดสินค้า",
                selector: function(row) {
                    return row.product_barcode || "-";
                },
                sortable: true,
                sortField: "product_barcode",
                minWidth: "170px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return unit.barcode || "-";
                        }
                    });
                }
            },
            {
                name: "จำนวนสินค้าจอง",
                selector: function(row) {
                    return row.reserve_unit_text || "-";
                },
                sortable: true,
                sortField: "reserve_amount_item",
                minWidth: "180px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return "".concat(integerText(unit.reserve_amount), " ").concat(unit.unit_name || "-");
                        }
                    });
                }
            },
            {
                name: "มูลค่าจอง",
                selector: function(row) {
                    return row.reserve_net || 0;
                },
                sortable: true,
                sortField: "reserve_net",
                right: true,
                minWidth: "140px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "w-100 text-right",
                                children: numberText(unit.reserve_net)
                            });
                        }
                    });
                }
            },
            {
                name: "จำนวนสินค้าส่งจริง",
                selector: function(row) {
                    return row.delivery_unit_text || "-";
                },
                sortable: true,
                sortField: "delivery_amount_item",
                minWidth: "190px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return "".concat(integerText(unit.delivery_amount), " ").concat(unit.unit_name || "-");
                        }
                    });
                }
            },
            {
                name: "มูลค่าส่งจริง",
                selector: function(row) {
                    return row.delivery_net || 0;
                },
                sortable: true,
                sortField: "delivery_net",
                right: true,
                minWidth: "150px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "w-100 text-right",
                                children: numberText(unit.delivery_net)
                            });
                        }
                    });
                }
            },
            {
                name: "ต้นทุน",
                selector: function(row) {
                    return row.product_cost || 0;
                },
                sortable: true,
                sortField: "product_cost",
                right: true,
                minWidth: "130px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        row: row,
                        render: function(unit) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "w-100 text-right",
                                children: numberText(unit.product_cost)
                            });
                        }
                    });
                }
            }
        ];
    }, []);
    var fetchData = function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_pId = _ref.pId, pId = _ref_pId === void 0 ? pageId : _ref_pId, _ref_pSize = _ref.pSize, pSize = _ref_pSize === void 0 ? pageSize : _ref_pSize, _ref_resetList = _ref.resetList, resetList = _ref_resetList === void 0 ? false : _ref_resetList;
        var _filters_searchTxt;
        var payload = _object_spread({
            sdate: filterTextAndNum(filters.startDate) ? moment(filters.startDate).format("YYYY-MM-DD") : "",
            edate: filterTextAndNum(filters.endDate) ? moment(filters.endDate).format("YYYY-MM-DD") : "",
            brandid: filters.brandId ? Number(filters.brandId) : null,
            shopid: filters.shopId ? Number(filters.shopId) : null,
            saleid: filters.saleId ? Number(filters.saleId) : null,
            searchTxt: ((_filters_searchTxt = filters.searchTxt) === null || _filters_searchTxt === void 0 ? void 0 : _filters_searchTxt.trim()) || "",
            salestatuses: (filters.saleStatuses || []).map(function(item) {
                return item.value;
            }),
            statuses: (filters.reserveStatuses || []).map(function(item) {
                return item.value;
            }),
            pageId: pId,
            pageSize: pSize
        }, (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortField) && (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortValue) && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        if (resetList) {
            setRowData([]);
        }
        dispatch(getReportReserveProductSummary(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleSearch = function() {
        setSortModel([]);
        setFilters({
            brandId: brandId,
            shopId: shopId,
            saleId: saleId,
            searchTxt: searchTxt,
            saleStatuses: saleStatuses,
            reserveStatuses: reserveStatuses,
            startDate: startDate,
            endDate: endDate
        });
        setPageId(1);
    };
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartDate(moment(range.startDate).format("YYYY-MM-DD"));
            setEndDate(moment(range.endDate).format("YYYY-MM-DD"));
        }
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        if (!field) return;
        setSortModel({
            sortField: field,
            sortValue: sortDirection
        });
        setPageId(1);
    };
    useEffect(function() {
        dispatch(allBrand({
            status: 1
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        fetchData({
            resetList: true
        });
    }, [
        filters,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        var isFetching = getReportReserveProductSummaryReducer.isFetching || allBrandReducer.isFetching || getShopReducer.isFetching || allSetUserReducer.isFetching;
        setIsLoading(isFetching);
        if (getReportReserveProductSummaryReducer.data && !getReportReserveProductSummaryReducer.isError) {
            var datas = getReportReserveProductSummaryReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            setRowData(datas.data || []);
            setSummary(datas.summary || {});
            var pagination = datas.pagination || {};
            setTotalPage(pagination.totalPage || 0);
            setTotalAmount(pagination.total || 0);
        }
    }, [
        getReportReserveProductSummaryReducer,
        allBrandReducer,
        getShopReducer,
        allSetUserReducer
    ]);
    useEffect(function() {
        if (allBrandReducer.data && !allBrandReducer.isError) {
            var rows = allBrandReducer.data.data || [];
            setBrandOptions([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(rows.map(function(brand) {
                return {
                    value: brand.set_brand_id,
                    label: brand.set_brand_name || brand.set_brand_nameen || "-"
                };
            })))));
        }
    }, [
        allBrandReducer
    ]);
    useEffect(function() {
        if (getShopReducer.data && !getShopReducer.isError) {
            var seen = new Set();
            var rows = getShopReducer.data.data || [];
            var shops = rows.filter(function(shop) {
                var _shop_shShop;
                var name = (_shop_shShop = shop.shShop) === null || _shop_shShop === void 0 ? void 0 : _shop_shShop.sh_shop_name;
                if (!name || seen.has(name)) return false;
                seen.add(name);
                return true;
            }).map(function(shop) {
                var _shop_shShop;
                return {
                    value: shop.sh_branch_shid,
                    label: ((_shop_shShop = shop.shShop) === null || _shop_shShop === void 0 ? void 0 : _shop_shShop.sh_shop_name) || "-"
                };
            });
            setShopOptions([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(shops))));
        }
    }, [
        getShopReducer
    ]);
    useEffect(function() {
        if (allSetUserReducer.data && !allSetUserReducer.isError) {
            var users = allSetUserReducer.data.data || [];
            setSaleOptions([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(users.filter(function(user) {
                return user.sys_user_role_id === 3;
            }).map(function(user) {
                return {
                    value: user.sys_user_id,
                    label: "".concat(user.sys_user_fullname, " ( ").concat(user.sys_user_nname, " ) ")
                };
            })))));
        }
    }, [
        allSetUserReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("style", {
                children: '\n        .reserve-product-summary-filter .datepicker2,\n        .reserve-product-summary-filter .form-control,\n        .reserve-product-summary-filter .reserve-summary-select__control {\n          min-height: 38px;\n          height: 38px;\n        }\n\n        .reserve-product-summary-filter .reserve-summary-select__value-container {\n          min-height: 36px;\n          height: 36px;\n          overflow: hidden;\n          flex-wrap: nowrap;\n        }\n\n        .reserve-product-summary-filter .reserve-summary-select__indicators {\n          height: 36px;\n        }\n\n        .reserve-product-summary-filter > [class*="col-"] {\n          display: flex;\n          flex-direction: column;\n        }\n\n        .reserve-product-summary-filter .form-st-3 {\n          width: 100%;\n          margin-bottom: 0 !important;\n        }\n\n        .reserve-product-summary-filter .btn {\n          min-height: 38px;\n        }\n      '
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสรุปใบจองตามสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสรุปใบจองตามสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsxs(CardBody, {
                        className: "p-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "reserve-product-summary-filter g-3 align-items-end",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                            value: dateRange,
                                            onChange: handleDateRangeChange,
                                            groupClassName: "mb-0 form-st-3",
                                            classNamePrefix: "reserve-summary-select"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่จองเริ่มต้น"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: startDate ? moment(startDate).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setStartDate(moment(date).isValid() ? moment(date).format("YYYY-MM-DD") : "");
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: startDate ? moment(startDate).format("DD/MM/YYYY") : "",
                                                    maxDate: endDate ? moment(endDate).toDate() : null,
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่จองสิ้นสุด"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: endDate ? moment(endDate).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setEndDate(moment(date).isValid() ? moment(date).format("YYYY-MM-DD") : "");
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: endDate ? moment(endDate).format("DD/MM/YYYY") : "",
                                                    minDate: startDate ? moment(startDate).toDate() : null,
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "แบรนด์สินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    classNamePrefix: "reserve-summary-select",
                                                    placeholder: "เลือกแบรนด์สินค้า",
                                                    options: brandOptions,
                                                    value: brandOptions.find(function(opt) {
                                                        return opt.value === brandId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setBrandId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "รหัสสินค้า / บาร์โค้ด / ชื่อสินค้า",
                                                    onChange: function(e) {
                                                        setSearchTxt(e.target.value);
                                                    },
                                                    value: searchTxt
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    classNamePrefix: "reserve-summary-select",
                                                    placeholder: "เลือกร้านค้า",
                                                    options: shopOptions,
                                                    value: shopOptions.find(function(opt) {
                                                        return opt.value === shopId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setShopId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกเซลล์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    classNamePrefix: "reserve-summary-select",
                                                    placeholder: "เลือกเซลล์",
                                                    options: saleOptions,
                                                    value: saleOptions.find(function(opt) {
                                                        return opt.value === saleId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setSaleId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "สถานะเซลล์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    classNamePrefix: "reserve-summary-select",
                                                    placeholder: "สถานะเซลล์",
                                                    options: reserveSummarySaleStatusOptions,
                                                    value: saleStatuses,
                                                    onChange: function(items) {
                                                        return setSaleStatuses(items || []);
                                                    },
                                                    isMulti: true,
                                                    closeMenuOnSelect: false
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "สถานะ"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    classNamePrefix: "reserve-summary-select",
                                                    placeholder: "สถานะ",
                                                    options: reserveSummaryReserveStatusOptions,
                                                    value: reserveStatuses,
                                                    onChange: function(items) {
                                                        return setReserveStatuses(items || []);
                                                    },
                                                    isMulti: true,
                                                    closeMenuOnSelect: false
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        xl: 1,
                                        className: "d-flex align-items-end",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "danger",
                                            className: "w-100 mb-0",
                                            onClick: handleSearch,
                                            children: "ค้นหา"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "g-2 mt-4",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 1,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนสินค้า",
                                            value: integerText(summary.total_product)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 1,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนใบจอง",
                                            value: integerText(summary.total_reserve_count)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "สินค้าจอง",
                                            value: integerText(summary.total_reserve_amount_item)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "มูลค่าจอง",
                                            value: numberText(summary.total_reserve_net)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "สินค้าส่งจริง",
                                            value: integerText(summary.total_delivery_amount_item)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "มูลค่าส่งจริง",
                                            value: numberText(summary.total_delivery_net)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "ต้นทุนรวม",
                                            value: numberText(summary.total_product_cost)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนที่ไม่ได้จัดส่ง",
                                            value: integerText(summary.total_not_delivery_amount_item)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "มูลค่าที่ยังไม่ได้จัดส่ง",
                                            value: numberText(summary.total_not_delivery_net)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนที่ยกเลิก",
                                            value: integerText(summary.total_cancel_amount_item)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "มูลค่าที่ยกเลิก",
                                            value: numberText(summary.total_cancel_net)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: setPageId,
                            onChangePageSize: setPageSize,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: getReportReserveProductSummaryReducer.isFetching
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: reservationModal.show,
                onHide: function() {
                    setReservationModal({
                        show: false,
                        product: null,
                        reservations: []
                    });
                    setReservationModalPageId(1);
                    setReservationModalSortModel({});
                },
                size: "xl",
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsxs(Modal.Title, {
                            children: [
                                "ข้อมูลใบจอง ",
                                ((_reservationModal_product = reservationModal.product) === null || _reservationModal_product === void 0 ? void 0 : _reservationModal_product.product_code) || ""
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fw-semibold",
                                        children: ((_reservationModal_product1 = reservationModal.product) === null || _reservationModal_product1 === void 0 ? void 0 : _reservationModal_product1.product_nameth) || "-"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "tc-7 fs-14",
                                        children: [
                                            "จำนวนใบจอง ",
                                            integerText(reservationModal.reservations.length),
                                            " รายการ"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                    item: paginatedModalReservations,
                                    columns: modalReservationColumns,
                                    isSelectRows: false,
                                    currentPage: reservationModalPageId,
                                    currentPageSize: reservationModalPageSize,
                                    onChangePage: setReservationModalPageId,
                                    onChangePageSize: function(size) {
                                        setReservationModalPageSize(size);
                                        setReservationModalPageId(1);
                                    },
                                    totalPage: Math.max(Math.ceil(modalReservations.length / reservationModalPageSize), 1),
                                    totalAmount: modalReservations.length,
                                    sortModel: reservationModalSortModel,
                                    onChangeSort: setReservationModalSortModel,
                                    handleSort: handleModalSort,
                                    loading: false
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
